import type { Routes } from "shared/react";
import { splitEntity } from "shelving";
import { ChallengePage } from "../challenge/ChallengePage.js";
import { ListPage } from "../list/ListPage.js";
import { NotePage } from "../note/NotePage.js";
import { PostPage } from "../post/PostPage.js";
import { RewardPage } from "../reward/RewardPage.js";
import { useShortcutItem } from "../util/data.js";
import { ChallengeCreatePage } from "./ChallengeCreatePage.js";
import { ChallengesCreatedPage } from "./ChallengesCreatedPage.js";
import { CreatedPage } from "./CreatedPage.js";
import { useCreatorContext } from "./CreatorContext.js";
import { ListCreatePage } from "./ListCreatePage.js";
import { ListsCreatedPage } from "./ListsCreatedPage.js";
import { NoteCreatePage } from "./NoteCreatePage.js";
import { NotesCreatedPage } from "./NotesCreatedPage.js";
import { BackgroundCreatePage, BadgeCreatePage, ReactionCreatePage } from "./RewardCreatePage.js";
import { BackgroundsCreatedPage, BadgesCreatedPage, ReactionsCreatedPage } from "./RewardsCreatedPage.js";

export const CREATOR_ROUTES: Routes = {
	"/create": CreatedPage,
	"/challenges": ChallengesCreatedPage,
	"/challenges/new": ChallengeCreatePage,
	"/badges": BadgesCreatedPage,
	"/badges/new": BadgeCreatePage,
	"/backgrounds": BackgroundsCreatedPage,
	"/backgrounds/new": BackgroundCreatePage,
	"/reactions": ReactionsCreatedPage,
	"/reactions/new": ReactionCreatePage,
	"/lists": ListsCreatedPage,
	"/lists/new": ListCreatePage,
	"/notes": NotesCreatedPage,
	"/notes/new": NoteCreatePage,
	"/{slug}": _CreatorShortcutRouter,
};

function _CreatorShortcutRouter({ slug }: { slug: string }): React.ReactElement {
	const creator = useCreatorContext();
	const content = useShortcutItem(creator, slug);
	const [type, id] = splitEntity(content.data.target);
	if (type === "challenge") return <ChallengePage id={id} />;
	if (type === "reward") return <RewardPage id={id} />;
	if (type === "note") return <NotePage id={id} />;
	if (type === "list") return <ListPage id={id} />;
	if (type === "post") return <PostPage id={id} />;
	throw new Error(`Invalid creator shortcut type "${type}"`);
}
